import type { SVGProps } from "react";

const Gray = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="220" height="199" viewBox="0 0 220 199" fill="none" {...props}>
    <ellipse cx="110" cy="105.658" rx="75.2632" ry="75.2632" fill="url(#paint0_linear_1257_926)" />
    <g filter="url(#filter0_dd_1257_926)">
      <path
        d="M110.692 20.563C84.7384 20.563 63.6239 41.6775 63.6239 67.6306C63.6239 99.8391 105.745 147.123 107.538 149.12C109.223 150.996 112.164 150.993 113.845 149.12C115.638 147.123 157.759 99.8391 157.759 67.6306C157.759 41.6775 136.645 20.563 110.692 20.563ZM110.692 91.3115C97.6339 91.3115 87.0109 80.6883 87.0109 67.6306C87.0109 54.5728 97.6342 43.9498 110.692 43.9498C123.749 43.9498 134.372 54.5731 134.372 67.6308C134.372 80.6886 123.749 91.3115 110.692 91.3115Z"
        fill="url(#paint1_linear_1257_926)"
      />
    </g>
    <circle
      opacity="0.5"
      cx="110.149"
      cy="66.78"
      r="47.2206"
      transform="rotate(45 110.149 66.78)"
      fill="url(#paint2_linear_1257_926)"
    />
    <circle cx="30.3947" cy="57.8947" r="7.23684" fill="white" />
    <ellipse cx="26.0527" cy="188.158" rx="10.1316" ry="10.1316" fill="white" />
    <ellipse cx="209.868" cy="81.0526" rx="10.1316" ry="10.1316" fill="white" />
    <ellipse cx="193.947" cy="41.9737" rx="5.78947" ry="5.78947" fill="white" />

    <defs>
      <filter
        id="filter0_dd_1257_926"
        x="46.9572"
        y="20.563"
        width="127.469"
        height="163.296"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="3.33333" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1257_926" />
        <feOffset dy="6.66667" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1257_926" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="3.33333" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1257_926" />
        <feOffset dy="16.6667" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1257_926" result="effect2_dropShadow_1257_926" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1257_926" result="shape" />
      </filter>
      <filter
        id="filter1_b_1257_926"
        x="74"
        y="117"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1257_926" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1257_926" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_1257_926"
        x1="110"
        y1="30.3947"
        x2="110"
        y2="180.921"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F3EDFA" />
        <stop offset="1" stopColor="#EBEAED" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1257_926"
        x1="145.682"
        y1="40.5574"
        x2="103.875"
        y2="133.713"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9FAFB" />
        <stop offset="1" stopColor="#E4E7EC" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1257_926"
        x1="73.8906"
        y1="35.5807"
        x2="157.37"
        y2="114.001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D0D5DD" />
        <stop offset="0.350715" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const IllustrationMap = { Gray };
